export default __webpack_public_path__ + "static/media/640_business04-nl-mobile.ffcc2955.png";